import { render, staticRenderFns } from "./WineTypeCreate.vue?vue&type=template&id=07a8d601"
import script from "./WineTypeCreate.vue?vue&type=script&lang=ts"
export * from "./WineTypeCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports